// extracted by mini-css-extract-plugin
export default {"confetti":"Confetti_confetti__jQbfS","opas":"Confetti_opas__Pq7s+"};